export default __webpack_public_path__ + "static/media/5.3fcb65c7.png";